import Api from '../api/reconApi.js';
import * as lookups from './lookups';
import { updateMpiWorkItem } from './apiMpiWorkItems';
import { sendEstimate } from './apiEstimates';
import { partsForMpiWorkItem, partsForAppraisal, partsTotals } from '../components/Parts/partsUtils';

function rollUpMpiPartsTotals(mpiIds, vehicle_id) {
	return (dispatch, getState) => {
		const active_vehicle = getState().settings_refresh?.active_vehicle || {};
		const workItems = active_vehicle.mpi_work_items || [];
		mpiIds.forEach((id) => {
			const item = workItems.find(w => String(w.id) === String(id));
			if (!item) return;
			const total = partsTotals(partsForMpiWorkItem(active_vehicle, id)).total;
			if (Math.abs(Number(item.parts_total || 0) - total) < 0.005) return;
			const laborTotal = Number(item.labor_total || 0);
			dispatch(updateMpiWorkItem(id, {
				vehicle_id,
				parts_total: Number(total.toFixed(2)),
				estimate_total: Number((total + laborTotal).toFixed(2)),
			}));
		});
	};
}

function rollUpAppraisalPartsTotals(appraisalIds, vehicle_id) {
	return (dispatch, getState) => {
		const state = getState();
		const active_vehicle = state.settings_refresh?.active_vehicle || {};
		const appraisals = state.settings_refresh?.appraisals || [];
		appraisalIds.forEach((id) => {
			const appraisal = appraisals.find(a => String(a.id) === String(id));
			if (!appraisal) return;
			const total = partsTotals(partsForAppraisal(active_vehicle, id)).total;
			if (Math.abs(Number(appraisal.parts_price || 0) - total) < 0.005) return;
			const laborTotal = Number(appraisal.labor_units || 0) * Number(appraisal.labor_price || 0);
			const estimate_total = Number((total + laborTotal).toFixed(2));
			dispatch(sendEstimate(id, {
				vehicle_id,
				parts_price: Number(total.toFixed(2)),
				estimate_total,
				estimate: estimate_total,
			}, 'addEstimateError'));
		});
	};
}

export function addWorkItemPart(data, errorType) {
	return dispatch => Api.postData('work_item_parts/', data).then(resp => dispatch(lookups.activeVehicleWithPromise(data.vehicle_id))).catch(ex => Api.handleApiError(ex, errorType));
}

export function addWorkItemPartsBulk(items, vehicle_id, errorType) {
	return async (dispatch) => {
		for (let i = 0; i < items.length; i++) {
			await Api.postData('work_item_parts/', items[i]).catch(ex => Api.handleApiError(ex, errorType));
		}
		await dispatch(lookups.activeVehicleWithPromise(vehicle_id));
		const mpiIds = [...new Set(items
			.filter(it => it.work_item_source === 'new_work_items' && it.mpi_work_item_id)
			.map(it => it.mpi_work_item_id))];
		if (mpiIds.length) dispatch(rollUpMpiPartsTotals(mpiIds, vehicle_id));
		const appraisalIds = [...new Set(items
			.filter(it => it.work_item_source === 'appraisals' && it.appraisal_id)
			.map(it => it.appraisal_id))];
		if (appraisalIds.length) dispatch(rollUpAppraisalPartsTotals(appraisalIds, vehicle_id));
		return null;
	};
}

export function updateWorkItemPart(id, data, errorType) {
	return dispatch => Api.patchData(`work_item_parts/${id}`, data).then(() => dispatch(lookups.activeVehicleWithPromise(data.vehicle_id))).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateWorkItemPartRaw(id, data, errorType) {
	return dispatch => Api.patchData(`work_item_parts/${id}`, data).then(() => {}).catch(ex => Api.handleApiError(ex, errorType));
}

export function softDeleteWorkItemPart(id, vehicle_id, errorType) {
	return dispatch => Api.patchData(`work_item_parts/${id}`, { deleted: true, vehicle_id }).then(() => dispatch(lookups.activeVehicleWithPromise(vehicle_id))).catch(ex => Api.handleApiError(ex, errorType));
}
